import classNames from "classnames";
import Circle, { CircleProps } from "./Circle";

function Badge({ classname, ...props }: CircleProps) {
  return (
    <Circle
      {...props}
      classname={classNames("absolute -right-2 -top-2 z-10", classname)}
    />
  );
}

export default Badge;
